import api from './api';

// 域名状态枚举
export enum DomainStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

// 域名状态配置
export const DOMAIN_STATUS_CONFIG = {
  [DomainStatus.ACTIVE]: {
    text: '生效',
    color: 'green',
    icon: 'CheckCircleOutlined',
  },
  [DomainStatus.INACTIVE]: {
    text: '未生效',
    color: 'red',
    icon: 'CloseCircleOutlined',
  },
};

// 域名接口
export interface Domain {
  id: number;
  user_id: number;
  client_id: number;
  client_name?: string;
  domain_name: string;
  description: string;
  status: DomainStatus;
  created_at: string;
  updated_at: string;
}

// 域名列表请求参数
export interface DomainListRequest {
  page?: number;
  size?: number;
  status?: string;
  keyword?: string;
  id?: number;
}

// 域名列表响应
export interface DomainListResponse {
  success: boolean;
  data: {
    list: Domain[];
    total: number;
    page: number;
    size: number;
  };
}

// 域名详情响应
export interface DomainDetailResponse {
  success: boolean;
  data: Domain;
}

// 域名创建请求参数
export interface CreateDomainRequest {
  domain_name: string;
  description?: string;
  status?: string;
}

// 域名更新请求参数
export interface UpdateDomainRequest {
  id: number;
  domain_name?: string;
  description?: string;
  status?: string;
}

// 域名删除请求参数
export interface DeleteDomainRequest {
  id: number;
}

// 域名切换状态请求参数
export interface ToggleDomainRequest {
  id: number;
}

export interface AssignDomainRequest {
  id: number;
  client_id: number;
}

// 域名服务类
export class DomainService {
  // 获取域名列表
  static async getDomainsList(params: DomainListRequest = {}): Promise<DomainListResponse> {
    const response = await api.post('/api/domains/list', params);
    return response.data;
  }

  // 创建域名
  static async createDomain(params: CreateDomainRequest): Promise<DomainDetailResponse> {
    return api.post('/api/domains/create', params);
  }

  // 获取域名详情
  static async getDomainDetail(id: number): Promise<DomainDetailResponse> {
    return api.post('/api/domains/detail', { id });
  }

  // 更新域名
  static async updateDomain(params: UpdateDomainRequest): Promise<DomainDetailResponse> {
    return api.post('/api/domains/update', params);
  }

  // 删除域名
  static async deleteDomain(params: DeleteDomainRequest): Promise<{ success: boolean; message: string }> {
    return api.post('/api/domains/delete', params);
  }

  // 切换域名状态
  static async toggleDomain(params: ToggleDomainRequest): Promise<{ success: boolean; message: string; data: { id: number; status: DomainStatus } }> {
    return api.post('/api/domains/toggle', params);
  }

  // 分配域名
  static async assignDomain(params: AssignDomainRequest): Promise<{ success: boolean; message: string }> {
    return api.post('/api/domains/assign', params);
  }
}

// 导出域名服务实例
export const domainService = DomainService;
